export default __webpack_public_path__ + "static/media/weather-icon-512.db9f65c0.png";